import { Box } from '@mui/material';

export const LoginCard = ({ children }) => (
  <Box
    sx={{
      display: 'flex',
      width: '100%',
      height: '100%',
    }}
  >
    {children}
  </Box>
);
